import React from 'react'
import '../../../flight/flightDetail/FlightDetails.css'

// Reuses flight's exact .fdTabs/.fdTab classes (see flightDetail/FlightDetails.jsx)
// so this looks identical to the flight tab bar. All five tabs now have real
// content behind them (see SeatBookingPanel.jsx).
const TABS = [
    { key: 'selectSeat', label: 'SELECT SEAT' },
    { key: 'boardingDrop', label: 'BOARDING/DROP POINTS' },
    { key: 'photosAmenities', label: 'PHOTOS & AMENITIES' },
    { key: 'ratingsReviews', label: 'RATINGS & REVIEWS' },
    { key: 'cancellation', label: 'CANCELLATION' },
]

const HAS_CONTENT = new Set(['selectSeat', 'boardingDrop', 'photosAmenities', 'ratingsReviews', 'cancellation'])

const SeatTab = ({ active = 'selectSeat', onChange }) => {
    return (
        <div className='fdTabs'>
            {TABS.map((tab) => (
                <div
                    key={tab.key}
                    className={`mt-4 fdTab ${tab.key === active ? 'active' : ''} ${!HAS_CONTENT.has(tab.key) ? 'fdTab--disabled' : ''}`}
                    onClick={() => HAS_CONTENT.has(tab.key) && onChange?.(tab.key)}
                >
                    {tab.label}
                </div>
            ))}
        </div>
    )
}

export default SeatTab
